<template>
  <div class="side-edit-content p-5">
    <strong class="title-main">{{ $t('views.seller.integrations.config.edit.title') }}</strong>
    <p class="subtitle d-block mt-3 mb-4">
      {{ $t('views.seller.integrations.config.edit.product') }}:
      <strong> {{ editGroupData?.product_name }}</strong>
    </p>

    <!-- Exibe url -->
    <div :class="isInputError('update_url')" @click="removeError('update_url')">
      <strong class="title-medium">{{ $t('views.seller.integrations.config.save.url.title') }}</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe a URL do Bitrix" class="form-input" v-model="url" @change="updateConnection" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_url') }}
      </span>
    </div>

    <!-- Exibe token -->
    <div :class="isInputError('update_token')" @click="removeError('update_token')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">API Key</strong>
      </div>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe o API Key do Bitrix" class="form-input" v-model="token" @change="updateConnection" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_token') }}
      </span>
    </div>

    <!-- Exibe pipeline-->
    <div :class="isInputError('update_pipeline')" @click="removeError('update_pipeline')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Pipeline <b class="optional">(opcional)</b></strong>
      </div>
      <multiselect 
        v-model="pipeline.value"
        :options="pipeline.items" 
        :multiple="false" 
        :show-labels="false"
        :searchable="false"
        :loading="pipeline.loading"
        :disabled="pipeline.block"
        @input="listStageBitrix"
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <span slot="noResult">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_pipeline') }}</span>
    </div>

    <!-- Exibe stages -->
    <div :class="isInputError('update_tag')" @click="removeError('update_tag')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Estágio <b class="optional">(opcional)</b></strong>
      </div>
      <multiselect 
        v-model="stage.value"
        :options="stage.items" 
        :multiple="false" 
        :show-labels="false" 
        :searchable="false"
        :loading="stage.loading"
        :disabled="stage.block"
        placeholder="Digite para pesquisar"
        class="new-style"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opcao desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
        <span slot="noResult">Nenhum item encontrado</span>
      </multiselect>
      <span class="show-error">{{ showError('update_tag') }}</span>
    </div>

    <!-- Lista eventos -->
    <div :class="isInputError('update_events')" @click="removeError('update_events')">
      <strong class="title-medium mt-4">{{ $t('views.seller.integrations.config.edit.event.title') }}</strong>
      <span class="show-error">{{ showError('update_events') }}</span>
      <div class="d-flex bd-highlight my-3">
        <div class="flex-fill bd-highlight">
          <switch-group :label="$t('views.seller.integrations.config.edit.event.label.sales')" v-model="editGroupEvents" :options="events.options_sales" />
        </div>
        <div class="flex-fill bd-highlight">
          <switch-group :label="$t('views.seller.integrations.config.edit.event.label.contracts')" v-model="editGroupEvents" :options="events.options_contracts" />
        </div>
      </div>
      <switch-group :label="$t('views.seller.integrations.config.edit.event.label.recovery')" v-model="editGroupEvents" :options="events.options_sales_recovery" />
    </div>

  </div>
</template>

<script>

import BitrixService from "@/services/resources/BitrixService";
import ConnectionService from '@/services/resources/ConnectionService';
import CallbackService from '@/services/resources/CallbackService';
import Multiselect from 'vue-multiselect';
import SwitchGroup from '@/components/shared/forms/SwitchGroup';

export default {
  name: "IntegrationsConfigUpdateBitrix",
  components: {
    Multiselect,
    SwitchGroup
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Bitrix' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    events: {
      type: Object,
      required: true,
      default: () => ({
        options_sales: [],
        options_contracts: [],
        options_sales_recovery: []
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    organizeEvents: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    editGroupData: {},
    editGroupEvents: [],
    url: '',
    token: '',
    pipeline: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
    stage: {
      block: true,
      loading: false,
      value: null,
      items: [],
    },
  }),
  methods: {
    async showEditCallback(data) {

      this.removeErrors([
        'update_url',
        'update_token',
        'update_pipeline',
        'update_stage',
        'update_events'
      ]);

      for (const item of ['pipeline', 'stage']) {
        this[item].block = true;
        this[item].value = null;
      }

      this.editGroupData = data;
      this.editGroupEvents = [];

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);
      this.$emit('update:productSelected', data.product_id);

      await this.getIntegrationToken(data.connection.id);
      await this.getEvents(data);
      await this.updateConnection(true);

      this.$emit('update:editGroupLoad', false);
    },
    async getIntegrationToken(id) {
      await ConnectionService.build().read(id, { suppressErrorNotify: true })
      .then(response => {
        const data = JSON.parse(response.data);
        this.url = data.base_url;
        this.token = data.api_key;
      })
      .catch(() => {
        this.mountInputError({
          url: ['URL não encontrada'],
          token: ['Token não encontrado']
        }, 'update_');
      });
    },
    async getEvents(data) {

      try {

        const encodedArgs = encodeURIComponent(data.argsJson);
        
        const response = await CallbackService.build().search({
          url: `integrations/group/${this.integration.id}/${data.product_id}?callback=${data.callback}&connection_id=${data.connection.id}&args=${encodedArgs}`,
        });
        
        this.editGroupEvents = response.events;

      } catch (error) {
        this.mountInputError({
          events: ['Eventos não encontrados']
        }, 'update_');
      }
    },
    async listStageBitrix(selectedValue, compare) { 

      if(!selectedValue) {
        return false;
      }

      this.stage.loading = true;
      this.stage.block = false;
      this.stage.value = [];

      try {
        const response = await BitrixService.build().read(`stage/${selectedValue.ID}?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

        this.stage.items = response.result.map(item => ({
          id: item.STATUS_ID,
          name: item.NAME
        }));

        if(compare) {
          const selectedValueStage = this.stage.items.find(item => item.id === this.editGroupData?.args?.stage_id);
            if(selectedValueStage) {
              this.stage.value = selectedValueStage;
            }
        }

      } catch (error) {
        this.stage.items = [];
      } finally {
        this.stage.loading = false;
      }
    },
    async updateConnection(compare) {

      if (this.url && this.token) {
        try {
          await BitrixService.build().read(`test?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

          this.pipeline.loading = true;
          this.pipeline.block = false;
          this.pipeline.value = [];

          try {
            const response = await BitrixService.build().read(`pipeline?url=${this.url}&token=${this.token}`, { suppressErrorNotify: true });

            this.pipeline.items = response.result.map(item => ({
              id: item.ID,
              name: item.NAME
            }));

            // Se compare, verifica os itens em editGroupData e add os values
            if (compare) {
              const selectedValue = this.pipeline.items.find(item => item.id === this.editGroupData?.args?.pipeline_id);
              if(selectedValue) {
                this.pipeline.value = selectedValue;
                this.listStageBitrix(selectedValue, true);
              }
            }
          } catch {
            this.pipeline.items = [];
            this.pipeline.value = null;
          } finally {
            this.pipeline.loading = false;
          }
        } catch (err) {
          this.mountInputError(err.response.data, 'update_');
        } finally {
          this.pipeline.loading = false;
          this.stage.loading = false;
        }
      }
    },
    async updateCallbacks(data) {

      this.$emit('update:loadingUpdate', true);

      try {

        const force = data?.force_update || false;

        const url = ((force) ? data.dataUpdate.url : this.url) || '';
        const token = ((force) ? data.dataUpdate.token : this.token) || '';
        const events = (force) ? data.dataUpdate.events : this.organizeEvents(this.editGroupEvents);
        const pipeline = ((force) ? data.dataUpdate.pipeline : this.pipeline?.value) || [];
        const stage = ((force) ? data.dataUpdate.stage : this.stage?.value) || [];

        const products = (force) ? data.products : data;

        const promises = products.map(async (product) => {

          const product_id = (force) ? product.product_id : product;
          const args = (force) ? product.args : this.editGroupData.argsJson;
          const connection_id = (force) ? product.connection_id : this.editGroupData.connection.id;
          const callback = (force) ? product.callback : this.editGroupData.callback;

          return CallbackService.build().update({
            args,
            connection_id,
            callback,
            url,
            token,
            pipeline,
            stage,
            events
          }, `integrations/group/${this.integration.id}/${product_id}`, { suppressErrorNotify: true });
        });

        await Promise.all(promises);

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        const message = products.length > 1 ?
          this.$t('views.seller.integrations.config.toast.update.success.message_multiple') :
          this.$t('views.seller.integrations.config.toast.update.success.message');

        this.$bvToast.toast(message, {
          title: this.$t('views.seller.integrations.config.toast.update.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

      } catch (err) {

        if (this.action.block && err.response.data.action) {
          
          if(!err.response.data.token) {
            err.response.data.token = ['URL ou Token inválido'];
          }

          delete err?.response?.data?.action;
          delete err?.response?.data?.tag;
          delete err?.response?.data?.list;
          delete err?.response?.data?.tags;
        }
        
        this.mountInputError(err.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
            title: this.$t('views.seller.integrations.config.toast.update.error.title'),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,
        });

      } finally {
        this.$emit('update:loadingUpdate', false);
      }
    },
  }
}
</script>